// extracted by mini-css-extract-plugin
module.exports =  {"formElement":"c8aezlDhIkg8UaPG0ApC","label":"RzMEPKL4kK748Kwf1a5V"};